// [#1039] Rutas del módulo Devoluciones: una sola vista con todo el flujo.
export default [
  {
    path: '',
    name: 'devoluciones',
    component: () => import(/* webpackChunkName: "devoluciones" */ '@/apps/devoluciones/pages/DevolucionesPage.vue'),
  },
]
